// import React, { useState, useEffect } from 'react';
// import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
// import { Outlet } from 'react-router-dom';
// import Header from './Header';
// import Sidebar from './Sidebar';

// const MainLayout = () => {
//   const theme = useTheme();
//   const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [loading, setLoading] = useState(true);

//   const handleSidebarToggle = () => {
//     if (isDesktop) {
//       // Always keep sidebar open on desktop
//       setSidebarOpen(true);
//     } else {
//       setSidebarOpen(!sidebarOpen);
//     }
//   };

//   const handleMobileMenuOpen = () => {
//     setMobileOpen(true);
//   };

//   const handleMobileMenuClose = () => {
//     setMobileOpen(false);
//   };

//   React.useEffect(() => {
//     if (!isDesktop) {
//       setSidebarOpen(false);
//       setMobileOpen(false);
//     } else {
//       setSidebarOpen(true);
//     }
//   }, [isDesktop]);

//   useEffect(() => {
//     // Immediately set loading to false to prevent black frame
//     setLoading(false);
//   }, []);

//   return (
//     <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f5f7fb', color: '#0F172A', border: 'none', outline: 'none', boxShadow: 'none' }}>
//       {/* Sidebar placed first so header and content align with it */}
//       <Sidebar
//         open={sidebarOpen}
//         onToggle={handleSidebarToggle}
//         mobileOpen={mobileOpen}
//         onMobileClose={handleMobileMenuClose}
//         loading={loading}
//       />

//       {/* Main column containing Header and page content */}
//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           minWidth: 0,
//           overflow: 'hidden',
//           transition: 'all .25s cubic-bezier(0.4, 0, 0.2, 1)',
//         }}
//       >
//         <Header
//           sidebarOpen={sidebarOpen}
//           isDesktop={isDesktop}
//           onMobileMenuOpen={handleMobileMenuOpen}
//         />

//         {/* Header Spacer */}
//         <Toolbar sx={{ minHeight: '64px !important' }} />

//         <Box
//           component="main"
//           sx={{
//             flex: 1,
//             overflow: 'auto',
//             p: { xs: 2, md: 3.5 },
//             maxWidth: '100%',
//             position: 'relative',
//             zIndex: 1,
//           }}
//         >
//           <Box
//             sx={{
//               maxWidth: '1280px',
//               mx: 'auto',
//               width: '100%',
//             }}
//           >
//             <Outlet />
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default MainLayout;

import React, { useState, useEffect } from 'react';
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from './Header';
import Sidebar from './Sidebar';
import { isRouteLocked } from '../../utils/planAccess';
import FollowupAlert from '../../pages/CRM/components/FollowupAlert';

const MainLayout = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const location = useLocation();
  const routeLocked = isRouteLocked(location.pathname);
  const isDashboard = location.pathname === '/dashboard';

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleSidebarToggle = () => {
    if (isDesktop) {
      setSidebarOpen(true);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  const handleMobileMenuOpen = () => {
    setMobileOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileOpen(false);
  };

  React.useEffect(() => {
    if (!isDesktop) {
      setSidebarOpen(false);
      setMobileOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [isDesktop]);

  useEffect(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    if (routeLocked) {
      toast.warn('This feature is not included in your current plan. Please upgrade to continue.');
    }
  }, [routeLocked]);

  if (routeLocked) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: 'transparent',
        color: 'text.primary',
        border: 'none',
        outline: 'none',
        boxShadow: 'none',
        transition: 'background-color .25s ease, color .25s ease'
      }}
    >
      <Sidebar
        open={sidebarOpen}
        onToggle={handleSidebarToggle}
        mobileOpen={mobileOpen}
        onMobileClose={handleMobileMenuClose}
        loading={loading}
      />

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        }}
      >
        <Header
          sidebarOpen={sidebarOpen}
          isDesktop={isDesktop}
          onMobileMenuOpen={handleMobileMenuOpen}
        />

        <Toolbar sx={{ minHeight: '64px !important' }} />

        <Box
          component="main"
          sx={{
            flex: 1,
            overflow: 'auto',
            px: { xs: 2, md: 3.5 },
            pb: { xs: 2, md: 3.5 },
            pt: isDashboard ? { xs: 0.5, md: 1 } : { xs: 2, md: 3.5 },
            maxWidth: '100%',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Box
            sx={{
              maxWidth: '1280px',
              mx: 'auto',
              width: '100%',
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>

      <FollowupAlert />
    </Box>
  );
};

export default MainLayout;